import Chart from 'chart.js/auto';
import {AlgoBase} from "./AlgoBase";
import Papaparse from "papaparse";

export class HerculesChartJS extends AlgoBase {

  constructor(target) {
    super("hercules", target, false);
    this.init();
  }

  async init() {

    this.algortihmData = await this.buildDataset("data/algorithms/Hercules.csv");

    const ctx = this.$widget.find("canvas");

    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.algortihmData.labels,
        datasets: [{
          label: 'Chiller energy', // [dynamic value in loadDataset()],
          data: this.algortihmData.mainDatasets[0],
          backgroundColor: '#6400FF',
        }, {
          label: 'Cooling Tower energy', // [dynamic value in loadDataset()],
          data: this.algortihmData.allDatasets[1],
          backgroundColor: '#E62B33',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
        },
        elements: {
          line: {
            tension: 0.3,
            borderColor: '#330808',
          }
        },
        scales: {
          x: {
            stacked: true,
            align: 'center',
            ticks: {
              font: {
                size: 10
              }
            }
          },
          y: {
            stacked: true,
            min: 0,
            max: 3000000,
            ticks: {
              callback: function (value, index, ticks) {
                const formatted = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add thousand separators
                return formatted + ' kWh'; // Append the unit
              }
            },
          }
        }
      }
    });

    this.loadDataset(0)

    this.initEvents();

    this.ready();
  }

  loadDataset(datasetIndex) {
    this.chart.data.datasets[1].data = this.algortihmData.allDatasets[1][datasetIndex];

    // Update dynamic strings from CMS
    this.chart.data.datasets[0].label = this.getLegendFromCMS(1, 1);
    this.chart.data.datasets[1].label = this.getLegendFromCMS(2, 1);
    this.chart.data.labels[0] = this.getLegendFromCMS(3, 1);
    this.chart.data.labels[1] = this.getLegendFromCMS(4, 1);
    this.chart.data.labels[2] = this.getLegendFromCMS(5, 1);

    super.loadDataset(datasetIndex);
  }

  async buildDataset(filename) {
    return await super.buildDatasetFromCSV(filename, 2);
  }

}
